// extracted by mini-css-extract-plugin
export default {"footer-dark":"Footer_footer-dark__TVHS5","footer-social":"Footer_footer-social__XAj2T","footer-bottom":"Footer_footer-bottom__RMiy+","copyright":"Footer_copyright__k0-x5"};